import { render, staticRenderFns } from "./FeesDetails.vue?vue&type=template&id=386ef7c5&scoped=true"
import script from "./FeesDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeesDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeesDetails.vue?vue&type=style&index=0&id=386ef7c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ef7c5",
  null
  
)

export default component.exports